import StarRatings from 'react-star-ratings';

function StarRating({ size = 25, isHalf = true, count = 5 }) {
  // Generate a random value between 2.5 and 5
  const getRandomRating = () => (Math.random() * 2.5) + 2.5;

  return (
    <div className="stars">
      <StarRatings
        rating={getRandomRating()}          // maps from 'value'
        numberOfStars={count}               // maps from 'count'
        starRatedColor="gold"               // same visual as before
        starDimension={`${size}px`}          // maps from 'size'
        starSpacing="2px"
        name="rating"
      />
    </div>
  );
}

export default StarRating;